import NotificationWrapper, { notificationStore, addNotification } from './NotificationWrapper'

export { notificationStore, addNotification };
export default NotificationWrapper;